import { getThemes } from '../../services/apiService';
import { setAllThemes, themesSelector } from '../reducers/themeReducer';

export function fetchAllThemes() {
  return async (dispatch, getState) => {
    const existingThemes = themesSelector(getState());
    if (!existingThemes.length) {
      const themes = await getThemes();
      dispatch(setAllThemes(themes));
    }
  };
}
